import(/* webpackMode: "eager" */ "/var/www/html/Ariel/src/app/contact/page.tsx");
